/* MDM — customer video rail.
 *
 *  - Shopify-hosted clips play only while at least half on screen, and pause
 *    when they leave, so a rail of eight videos never has eight decoding.
 *  - Always muted to start: browsers refuse autoplay with sound. The sound
 *    button unmutes one clip and re-mutes every other, so two clips can never
 *    talk over each other.
 *  - YouTube / Vimeo clips load their iframe only on tap. Embedding the player
 *    up front would pull ~1MB of third-party script per clip before anyone
 *    asked to watch.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setSound(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Mute' : 'Turn sound on');
    var icon = btn.querySelector('.mdm-icon');
    if (icon) icon.textContent = on ? 'volume_up' : 'volume_off';
  }

  function initVideos(root) {
    var videos = (root || document).querySelectorAll('[data-mdm-ugc-video]:not([data-ready])');
    if (!videos.length) return;

    var io = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting && !reduced) {
              if (v.preload === 'none') v.preload = 'metadata';
              var p = v.play();
              if (p && p.catch) p.catch(function () { /* autoplay blocked: poster stays */ });
            } else {
              v.pause();
            }
          });
        }, { threshold: 0.5 })
      : null;

    videos.forEach(function (v) {
      v.dataset.ready = '1';
      if (io) io.observe(v);

      var btn = v.parentElement.querySelector('[data-mdm-ugc-sound]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var turnOn = v.muted;
        // silence every other clip first
        document.querySelectorAll('[data-mdm-ugc-video]').forEach(function (other) {
          if (other === v) return;
          other.muted = true;
          var ob = other.parentElement.querySelector('[data-mdm-ugc-sound]');
          if (ob) setSound(ob, false);
        });
        v.muted = !turnOn;
        if (turnOn) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
        setSound(btn, turnOn);
      });
    });
  }

  function initExternal(root) {
    (root || document).querySelectorAll('[data-mdm-ugc-ext]:not([data-ready])').forEach(function (btn) {
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var type = btn.dataset.type;
        var id = btn.dataset.id;
        if (!id) return;
        var src = type === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0&portrait=0'
          : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
        var f = document.createElement('iframe');
        f.className = 'mdm-ugc__iframe';
        f.src = src;
        f.title = btn.getAttribute('aria-label') || 'Customer video';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        btn.replaceWith(f);
      });
    });
  }

  function init(root) {
    initVideos(root);
    initExternal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
